import styled from '@emotion/styled';
import { mediaQueries, remCalc, palette, teaserHoverOff, teaserHoverOn, font } from '../../css';
import { StyledSvg } from '../../UI/Icon/Icon.css';

const StyledLink = styled('a')(() => ({}));

const StyledContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: remCalc(15),
    ...teaserHoverOff('bottom'),
    ':hover': teaserHoverOn('bottom', 3),
}));

const StyledLogo = styled('div')(() => ({
    display: 'flex',
    marginRight: remCalc(5),
    zIndex: 1,
}));

const StyledIcon = styled('div')(() => ({
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    padding: remCalc(6, 6, 0),
    backgroundColor: palette('black'),

    [StyledSvg]: {
        fill: palette('white'),
    },
}));

const StyledTitle = styled('h3')(() => ({
    margin: 0,
    color: palette('white'),
    zIndex: 1,
    fontFamily: font.family.header,
    fontSize: font.size.xs,
    fontWeight: font.weight.medium,
    lineHeight: font.lineHeight.xs,
    textTransform: 'uppercase',
    [mediaQueries.smallLarge]: {
        fontSize: font.size.s,
        lineHeight: font.lineHeight.s,
    },
    [mediaQueries.mediumLarge]: {
        fontSize: font.size.m,
        lineHeight: font.lineHeight.m,
    },
    [mediaQueries.large]: {
        fontSize: font.size.l,
        lineHeight: font.lineHeight.l,
    },
}));

export { StyledContainer, StyledLink, StyledTitle, StyledLogo, StyledIcon };
